import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { toCents } from "@/utils/numberUtils";

export class UpdateValuationDto {
  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  startDate?: Date;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  endDate?: Date;

  @Transform(({ value }) => (value != null ? toCents(value) : value))
  @Expose()
  executedAmount?: number;

  @Expose()
  notes?: string | null;
}
